import { inject, Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { AllClientsLocal } from '../Interfaces/clients';
import { AllClients } from '../Interfaces/SQL-morning-responses';
import { LikutService } from './likut.service';
import { StoreService } from './store.service';

type ObligoCheckOptions = {
	client?: AllClients;
	addToCalculation?: number;
};

@Injectable({
	providedIn: 'root',
})
export class ClientService {
	private _ss = inject(StoreService);
	private _likut = inject(LikutService);
	// private fb = inject(FormBuilder);

	// clients$ = new BehaviorSubject<AllClientsLocal[]>([]);
	// selectedClient$ = new BehaviorSubject<AllClientsLocal | null>(null);

	// clientPageForm = this.fb.nonNullable.group({
	// 	search: [''],
	// 	cities: [<string[]>[]],
	// 	activeFilter: [<'outstanding-debt' | 'all' | 'teudot-all' | 'teudot-returns'>'outstanding-debt'],
	// });

	constructor() {}

	canPassObligoCheck(options: ObligoCheckOptions = { client: this._ss.OneClientInfo, addToCalculation: 0 }): boolean {
		const client = options.client ?? this._ss.OneClientInfo;
		const addToCalculation = options.addToCalculation ?? 0;

		// Check against number different than client's actual debt showing.
		// Added for Tubul
		const shouldUseAlternativeObligoCalculation = client && 'UsedObligo' in client;
		if (!client) return false;

		return client.BCO === 0 || (shouldUseAlternativeObligoCalculation ? +client.UsedObligo : +client.COD + +client.COC) + addToCalculation + (+client.AddObligo || 0) < client.CMC;
	}

	getAllClientMethod() {
		if (this._likut.isMekabel) {
			return this._ss.getLikutMekabelSuppliers();
		}
		return this._ss.GetAllClients();
	}
}
